import { createSlice } from "@reduxjs/toolkit";

const initialState: string | null = null;

const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    setRolesStore: (state: string | null, action: any | null) => {
      return action.payload;
    },
  },
});

export const { setRolesStore } = rolesSlice.actions;

export default rolesSlice.reducer;